import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect';
import { replace } from '../services/router-utils';
import URI from 'urijs';

const requireAuth = connectedReduxRedirect({
  authenticatedSelector: state => state.auth.isAuthenticated,
  redirectPath: '/login',
  wrapperDisplayName: 'requireAuth',
  redirectAction: args => {
    if (args.query.redirect) {
      args.query.redirect = URI(args.query.redirect)
        .search('')
        .toString();
    }
    return replace(args);
  },
});

export default requireAuth;
